<template>
  <div class="container">
    <QueryFrame
      :disablePage='disablePage'
      :count= 'count'
      :current="page"
      :showEmptyLine="true"
    >
      <div slot="table">
        <div style="margin-top: 5px; margin-bottom: 15px;">
          <div style="display: flex; justify-content: space-between;">
            <div style="display: flex;">
              <div style="margin-top: 8px; margin-left: 20px;">核对结果：</div>
              <lk-select
                class="depositItem"
                style="width: 200px"
                v-model="query.detailStatus"
                clearable
              >
              <lk-option v-for="(item,i) in resultList" :value='item.value' :key="i">
                {{item.name}}
              </lk-option>
              </lk-select>
              <div style="margin-top: 8px; margin-left: 20px;">近一个月是否修改税率：</div>
              <lk-select
                class="depositItem"
                style="width: 200px"
                v-model="query.rateChanged"
                clearable
              >
              <lk-option v-for="(item,i) in isChangeList" :value='item.value' :key="i">
                {{item.name}}
              </lk-option>
              </lk-select>
              <lk-button type="primary" style="margin-left: 20px;" @click="search">检索</lk-button>
            </div>
            <lk-button type="primary" @click="downloadResult">下载处理结果</lk-button>
          </div>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import tools from '../../services/tools';
import RetailDetailExpand from '../sale/RetailDetailExpand.vue';

export default {
  name: 'infusion',
  mixins: [mapState, queryMixins],
  data() {
    return {
      disablePage: true,
      phoneModel: { phone: '' },
      query: { detailStatus: '', rateChanged: '' },
      resultList: [
        { name: '税率异常', value: 1 },
        { name: '商品不匹配', value: 2 },
        { name: '需关注', value: 3 },
        { name: '税率正常', value: 4 },
      ],
      isChangeList: [
        { name: '是', value: 1 },
        { name: '否', value: 2 },
      ],
      tableData: [],
      columns: [
        {
          title: ' ',
          width: 80,
          type: 'index',
        },
        {
          title: '核对结果',
          minWidth: 116,
          key: 'statusName',
        },
        {
          title: '近一个月是否修改税率',
          width: 156,
          key: 'rateChangedString',
        },
        {
          title: '上次修改税率时间',
          minWidth: 116,
          key: 'rateChangedTimeString',
        },
        {
          title: 'Excel行号',
          width: 100,
          key: 'lineNum',
        },
        {
          title: '发票号',
          minWidth: 116,
          key: 'invoiceCode',
        },
        {
          title: '开票日期',
          minWidth: 116,
          key: 'invoiceDate',
        },
        {
          title: '导入商品名称',
          width: 300,
          key: 'goodsName',
          render: (h, params) => h('div', {
            class: {
              testCenter: true,
            },
          }, [params.row.retry == 1 ? h('lk-input', {
            on: {
              input: (value) => {
                params.row.goodsName = value;
              },
            },
            props: {
              value: params.row.goodsName,
            },
          }) : h('span', params.row.goodsName)]),
        },
        {
          title: '匹配商品',
          width: 200,
          key: 'matchSerialCodes',
          render: (h, params) => h('div', {
            class: {
              textCenter: false,
            },
          }, [
            h('span', params.row.matchSerialCodes),
            params.row.retry == 1 ? h('lk-button', {
              style: {
                marginTop: '-2px',
                fontSize: '12px',
              },
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.rematch({ detailId: params.row.id, goodsName: params.row.goodsName });
                },
              },
            }, '点击重试') : null,
          ]),
        },
        {
          title: '导入表税率',
          minWidth: 116,
          key: 'rates',
        },
        {
          title: 'ERP税率',
          minWidth: 116,
          key: 'matchRates',
        },
      ],
    };
  },
  methods: {
    search() {
      const params = this.query;
      this.getData(params);
    },
    getData(params) {
      params.verifyId = this.$route.params.id;
      tools.verifyDetail(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.forEach((item) => {
            const result = item;
            item.createTime = utils.exchangeTimeToSecond(item.createTime);
            if (item.invoiceDate) item.invoiceDate = utils.exchangeTimeToSecond(item.invoiceDate);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    downloadResult() {
      tools.verifyDownload({ verifyId: this.$route.params.id }).then((res) => {
        utils.downLoadExcel(res, `发票税率核对${this.$route.params.storeName}${this.$route.params.time}.xlsx`, true);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    rematch(value) {
      tools.verifyReMatch(value).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('匹配成功');
        } else {
          this.$Message.error(res.data.error);
        }
        this.getData({});
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getData({});
  },
  components: {
    QueryFrame,
  },
};
</script>
<style>
  .btns{
    margin-bottom: 12px;
    margin-left: 16px;
  }
  .sms {
    margin-left: 29px;
    margin-bottom: 20px;
    margin-top: 10px;
  }
  .phone {
    display:flex;
    margin-top: 20px;
    margin-left: 16px;
  }
</style>
